import { RouteProps } from "react-router";
import { connect } from "react-redux";

import { RootState } from "src/ipm-shared/store/model/reducers";

// import * as selectors from "src/bepaid/store/model/Fetch/selectors";
// import * as FormAction from "src/ipm-shared/components/Form/actions";

import * as actions from "src/bepaid/store/model/Fetch/actions";
import * as selectors from "src/bepaid/store/model/Fetch/selectors";

import View from "./View";

const mapStateToProps = (state: RootState) => ({
  accountCountryCode: selectors.getAccountCountryCode(state),
  currencyId: selectors.getAccountCurrencyId(state),
  countryId: selectors.getCurrentCountryId(state),
  isHongKongAccount: selectors.isHongKongAccount(state),
  residentialAddress: selectors.getResidentialAddress(state),
  paymentCountryCode: selectors.getPaymentCountryCode(state),
  paymentCurrencyCode: selectors.getPaymentCurrencyCode(state),
  getControl: (name: string, form: string) =>
    selectors.getControl(state, name, form),
  isBusinessAccount: selectors.getIsBusinessAccount(state),
  supplierPayoutType: selectors.supplierPayoutType(state),
  isSupplierPayoutUEN: selectors.isSupplierPayoutUEN(state)
});

const mapDispatchToProps = {
  getAddressByPostalCode: actions.getAddressByPostalCode,
  setControl: actions.setControl,
  resetErrors: actions.resetErrors,
  removeForm: actions.removeForm,
  validateAmount: actions.validateAmount,
  checkValidNoteToRecipient: actions.checkValidNoteToRecipient
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  RouteProps;

export default connect(mapStateToProps, mapDispatchToProps)(View);
